import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-10/task-02";

const task: Slide = {
  titleHtml:
    "What happens if an unbiased electrostatic speaker is excited by a sinusoidal<br>electrical signal of frequency 1 kHz?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
